import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-merchant-info-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './merchant-info-bar.component.html',
  styleUrls: ['./merchant-info-bar.component.scss']
})
export class MerchantInfoBarComponent {
  @Input() merchantName: string;
  @Input() taxId: string;
}
